var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"app-text-field-no-border rounded-lg",attrs:{"value":_vm.value,"required":_vm.required,"label":_vm.label,"rules":_vm.getValidations(),"filled":""},on:{"input":function (e) { return _vm.$emit('input', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }